export interface HelpArticleSummary {
  slug: string;
  title: string;
  description: string;
}

export const helpArticles: HelpArticleSummary[] = [
  {
    slug: "vat-margin-scheme",
    title: "Using the VAT Margin Scheme",
    description:
      "How Global Accounting works in Wilma — recording purchase VAT, selling parts, invoices, and the period report.",
  },
];
